import { render, staticRenderFns } from "./payment-info-tab.vue?vue&type=template&id=321480ce&scoped=true"
import script from "./payment-info-tab.vue?vue&type=script&lang=js"
export * from "./payment-info-tab.vue?vue&type=script&lang=js"
import style0 from "./payment-info-tab.vue?vue&type=style&index=0&id=321480ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321480ce",
  null
  
)

export default component.exports